import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios'; // We will use axios for making API requests
import { API_URL } from '../../constants/api';

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate(); // Hook to navigate to other routes

  // console.log('token:', token);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const verifyEmail = async () => {
    try {
      // API call to login
      const response = await axios.get(
        `${API_URL}/api/users/verify-email`,

        {
          headers: {
            Authorization: token ? `Bearer ${token}` : '',
          },
        }
      );
      // console.log('response:', response);
      if (response.data.success === 1) {
        setSuccess(response.data.message);

        const timer = setTimeout(() => {
          navigate('/login/user-login');
        }, 3000); // 3000ms = 3 seconds
        setError(null);

        return () => clearTimeout(timer); // cleanup
      } else {
        setError(response.data.message);
        setSuccess(null);
      }

      // Redirect to the dashboard
    } catch (error) {
      // Handle error (e.g., invalid credentials)
      console.log('error:', error.message);
      setError('Invalid email or password');
    }
  };

  useEffect(() => {
    verifyEmail();
  }, []);
  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <div className="col-md-4 p-4 border rounded shadow-lg bg-light">
        <h2 className="text-center mb-4">Email Verification</h2>

        {error && <div className="alert alert-danger">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}

        <a href="/login" className="text-decoration-none">
          Login
        </a>
      </div>
    </div>
  );
};

export default VerifyEmail;
